import { gql } from '@efficiently/client-core-graphql-models';

export const DETECT_PLAN_BOUNDARY = gql(`
	mutation DetectPlanBoundary($planItemId: String!) {
		detectPlanBoundary(planItemId: $planItemId) {
			...PlanDetectionRunFields
		}
	}
`);
